import styled from '@emotion/styled';

import useIntersectionAnimate from '../../../hooks/useIntersectionObserver';
import { PartnersListData } from './PartnersListData';
import Marquee from "react-fast-marquee";

const PartnersList = () => {
  useIntersectionAnimate('.intersection-animate', 'animate', {
    threshold: 0.1,
  });


  return (
    <Container className='intersection-animate'>
      <Marquee speed={120}>
        <WebWrapper>

          {PartnersListData.map((data, index) => (
            <ImageWrapper
              key={index}
            >
              <Img src={data.imageName} alt={`slider ${index + 1}`} />
            </ImageWrapper>
          ))}

        </WebWrapper>
      </Marquee>
    </Container>
  );
};

export default PartnersList;

const Container = styled.div`
  padding: 100px 0;
  // display: flex;
  // flex-direction: column;
  // align-items:center;
  // justify-content: center;
  gap: 40px;


  @media (max-width: 884px) {
    align-items: center;
    padding: 55px 0;
  }
`;


const WebWrapper = styled.div`
  display: flex;
  padding-left: 100px;
  gap: 100px;
  align-items: center;

  @media (max-width: 884px) {
    gap: 40px;
    padding-left: 100px;
  }
`;


const ImageWrapper = styled.div`
  width: 100%;
  max-width: 160px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  overflow: hidden;
`;

const Img = styled.img`
  width: 100%;
  height: auto;
  max-width: 160px;
  object-fit: contain;
  border-radius: 12px;

  @media (max-width: 884px) {
    max-width: 100px;
  }
`;


